import { HandoverTypeAreaReason } from '../src/app/interfaces/handover-type-area-reason';

export const HANDOVER_TYPES_AREA_REASON: HandoverTypeAreaReason[] = [
  {
    handoverTypeAreaReasonid: 1,
    fromAreaId: 1,
    fromAreaName: 'Drilling',
    toAreaId: 2,
    toAreaName: 'Completion & Workover',
    type: 'HO1',
    handoverTypeId: 1,
  },
];
